import React, { useLayoutEffect, useState } from "react";
import Default from "./Default/index";
import MandG from "./MandG/index";
import SUK from "./SUK/index";
import { custom1, custom2, custom4 } from "../../../Utils/static-strings";
import MandGSA from "./MandGSA";
const Index = (props) => {
  const [currentSkin, setCurrentSkin] = useState(null);

  useLayoutEffect(() => {
    if (props.skin) {
      setCurrentSkin(props.skin);
    }
  }, []);

  const handleSkin = () => {
    const skin = sessionStorage.getItem("skinName")?.toLowerCase();
    if (skin === custom2?.toLowerCase()) {
      return <MandG {...props} />;
    } else if (skin === custom4?.toLowerCase()) {
      return <MandGSA {...props} />;
    } else if (skin === custom1?.toLowerCase()) {
      return <SUK {...props} />;
    } else {
      return <Default {...props} />;
    }
  };
  return (
    <React.Fragment>{currentSkin !== null && handleSkin()}</React.Fragment>
  );
};
export default Index;
